import type { CatalogResponse } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

export async function getCatalog(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<CatalogResponse> {
  return platformApiRequest<CatalogResponse>('/v1/catalog', { signal }, fetchImpl);
}
